// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.posts {
  position: absolute;
  right: 5%;
  margin-top: 100px;
  width: 90%;
}
.posts .post {
  margin-bottom: 5px;
}
.posts .scrollPost {
  overflow-y: auto;
  width: 100%;
}
.posts .newsimg img {
  height: 100px;
}
.posts h3 {
  font-size: 0.7em;
  border-bottom: 3px solid black;
  padding: 5px;
  padding-left: 10px;
  cursor: pointer;
  margin-bottom: 0;
}
.posts h3 .date {
  font-family: inherit;
  display: inline-block;
  width: 200px;
  padding-left: 5px;
  font-size: 0.8em;
}
.posts .content {
  display: none;
  width: 100%;
  padding: 15px;
  margin-bottom: 15px;
  max-height: 25vh;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
}
.posts .content .ql-font-monospace {
  font-family: monospace !important;
}
.posts .content .ql-font-serif {
  font-family: serif !important;
}
.posts .content .text {
  font-size: 0.87em;
  line-height: 1.6em;
}
.posts .content .newsimg {
  padding-top: 0 !important;
  padding-left: 10px;
}
.posts .content .newsimg img {
  float: right;
}
@media screen and (max-width: 575px) {
  .posts .content .text,
  .posts .content img {
    width: 100%;
    height: 100%;
    display: block;
    position: relative;
  }
  .posts .content .text {
    padding-bottom: 50px;
  }
}

.btnContainer {
  width: 100%;
  text-align: right;
}
.btnContainer .btn {
  margin-right: 10px;
  background-color: rgba(255, 255, 255, 0.8);
}

@media screen and (max-width: 768px) {
  .posts {
    right: 0px;
  }
}
.posts .post:first-child .content {
  display: block;
}

@media screen and (max-width: 575px) {
  .posts {
    margin-top: 50px;
    width: 100%;
  }
  .posts h3 {
    font-size: 0.8em !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/postwidget/postwidget.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,SAAA;EACA,iBAAA;EACA,UAAA;AACF;AACE;EACE,kBAAA;AACJ;AAEE;EACE,gBAAA;EACA,WAAA;AAAJ;AAII;EACE,aAAA;AAFN;AAME;EACE,gBAAA;EAUA,8BAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAbJ;AACI;EACE,oBAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AACN;AASE;EACE,aAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,+BAAA;EACA,gCAAA;AAPJ;AASK;EACC,iCAAA;AAPN;AAUI;EACE,6BAAA;AARN;AAWI;EAGE,iBAAA;EACA,kBAAA;AAXN;AAcI;EAGE,yBAAA;EACA,kBAAA;AAdN;AAgBM;EACE,YAAA;AAdR;AAkBI;EAEE;;IAEE,WAAA;IACA,YAAA;IACA,cAAA;IACA,kBAAA;EAjBN;EAoBI;IACE,oBAAA;EAlBN;AACF;;AAuBA;EACE,WAAA;EACA,iBAAA;AApBF;AAsBE;EACE,kBAAA;EACA,0CAAA;AApBJ;;AAwBA;EACE;IACE,UAAA;EArBF;AACF;AA0BI;EACE,cAAA;AAxBN;;AA6BA;EACE;IACE,gBAAA;IACA,WAAA;EA1BF;EA4BE;IACE,2BAAA;EA1BJ;AACF","sourcesContent":[".posts {\r\n  position: absolute;\r\n  right: 5%;\r\n  margin-top: 100px;\r\n  width: 90%;\r\n\r\n  .post {\r\n    margin-bottom: 5px;\r\n  }\r\n\r\n  .scrollPost {\r\n    overflow-y: auto;\r\n    width: 100%;\r\n  }\r\n\r\n  .newsimg {\r\n    img {\r\n      height: 100px;\r\n    }\r\n  }\r\n\r\n  h3 {\r\n    font-size: 0.7em;\r\n\r\n    .date {\r\n      font-family: inherit;\r\n      display: inline-block;\r\n      width: 200px;\r\n      padding-left: 5px;\r\n      font-size: 0.8em;\r\n    }\r\n\r\n    border-bottom: 3px solid black;\r\n    padding: 5px;\r\n    padding-left: 10px;\r\n    cursor: pointer;\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  .content {\r\n    display: none;\r\n    width: 100%;\r\n    padding: 15px;\r\n    margin-bottom: 15px;\r\n    max-height: 25vh;\r\n    border-bottom-left-radius: 15px;\r\n    border-bottom-right-radius: 15px;\r\n\r\n     .ql-font-monospace{\r\n      font-family: monospace !important;\r\n    }\r\n\r\n    .ql-font-serif{\r\n      font-family: serif !important;\r\n    }\r\n\r\n    .text {\r\n      //  width: 65%;\r\n      //  display: inline-block;\r\n      font-size: 0.87em;\r\n      line-height: 1.6em;\r\n    }\r\n\r\n    .newsimg {\r\n      //  display: inline-block;\r\n      //  width: 30%;\r\n      padding-top: 0 !important;\r\n      padding-left: 10px;\r\n\r\n      img {\r\n        float: right;\r\n      }\r\n    }\r\n\r\n    @media screen and (max-width: 575px) {\r\n\r\n      .text,\r\n      img {\r\n        width: 100%;\r\n        height: 100%;\r\n        display: block;\r\n        position: relative;\r\n      }\r\n\r\n      .text {\r\n        padding-bottom: 50px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.btnContainer {\r\n  width: 100%;\r\n  text-align: right;\r\n\r\n  .btn {\r\n    margin-right: 10px;\r\n    background-color: rgba(255, 255, 255, 0.8);\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  .posts {\r\n    right: 0px;\r\n  }\r\n}\r\n\r\n.posts {\r\n  .post:first-child {\r\n    .content {\r\n      display: block;\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 575px) {\r\n  .posts {\r\n    margin-top: 50px;\r\n    width: 100%;\r\n\r\n    h3 {\r\n      font-size: 0.8em !important;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
